import { CognitoUserPool, CognitoUser } from 'amazon-cognito-identity-js';
import { defineMessages } from 'react-intl';

const POOL_ID = process.env.POOL_ID; // eslint-disable-line prefer-destructuring
const CLIENT_ID = process.env.CLIENT_ID; // eslint-disable-line prefer-destructuring

const poolData = {
  UserPoolId: POOL_ID,
  ClientId: CLIENT_ID,
};

const messages = defineMessages({
  UserNotFoundException: {
    id: 'cognito.userNotFound',
    defaultMessage: 'Login failed. Invalid e-mail address or password.',
  },
  LimitExceededException: {
    id: 'cognito.limitExceeded',
    defaultMessage: 'Attempt limit exceeded, please try again later.',
  },
  Throttling: {
    id: 'cognito.throttling',
    defaultMessage: 'The request was denied due to request throttling.',
  },
  ValidationError: {
    id: 'cognito.validationError',
    defaultMessage: 'The input failed validation.',
  },
  NotAuthorizedException: {
    id: 'cognito.notAuthorized',
    defaultMessage: 'Login failed. Invalid e-mail address or password.',
  },
  LoginFailedNotAuthorizedException: {
    id: 'cognito.loginFailedNotAuthorized',
    defaultMessage: 'Login failed. Invalid e-mail address or password.',
  },
  InvalidPasswordException: {
    id: 'cognito.invalidPassword',
    defaultMessage: 'Password failed to satisfy security requirements.',
  },
  ServiceUnavailable: {
    id: 'cognito.serviceUnavailable',
    defaultMessage: 'The request has failed due to a temporary failure of the server.',
  },
  UserIsLocked: {
    id: 'cognito.UserIsLocked',
    defaultMessage: 'This user has been locked due to excessive invalid password attempts.',
  },
  UserLambdaValidationException: {
    id: 'cognito.UserLambdaValidationException',
    defaultMessage: 'This user has been locked due to excessive invalid password attempts.',
  },
  UnknownError: {
    id: 'cognito.unknownError',
    defaultMessage: 'Unknown Error.',
  },
});

function translateError(errorCode) {
  const msg = messages[errorCode] || messages.UnknownError;
  return msg;
}

function getSession(currentUser) {
  return new Promise((resolve, reject) => {
    if (!currentUser) {
      reject(new Error('No current user'));
    } else {
      currentUser.getSession((err, result) => {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    }
  });
}

class CognitoService {
  constructor(aPool) {
    this._pool = new CognitoUserPool(aPool);
  }

  getCognitoUser(username) {
    return new CognitoUser({
      Username: username,
      Pool: this._pool,
    });
  }

  getCurrentUserWithSession() {
    const currentUser = this.getCurrentUser();
    return getSession(currentUser).then(() => currentUser);
  }

  getCurrentUser() {
    return this._pool.getCurrentUser();
  }

  // starts logout flow.
  logout() {
    const currentUser = this.getCurrentUser();
    if (currentUser) {
      currentUser.signOut();
    }
  }
}

const cognitoService = new CognitoService(poolData);
export { cognitoService as default, translateError };
